import React from 'react';
import PropTypes from 'prop-types';

const InvoiceDetails = ({ props }) => {
    const value = props.shipping.invoiceData;
    return (
        <li className="item item__grouped">
            <span className="item__label">Dane do faktury</span>
            <div className="item__value">
                {value && <span className="item__new-line"> {value.name}</span>}<br />
                {value && <span className="item__new-line"> {value.street}</span>}<br />
                {value && <span className="item__new-line"> {value.postcode} {value.city}</span>}<br />
                {value && <span className="item__new-line"> NIP: {value.taxId}</span>}
            </div>
        </li>
    );
};

InvoiceDetails.propTypes = {
    name: PropTypes.string,
    category: PropTypes.string,
    props: PropTypes.object,
};

export default InvoiceDetails;
